import { NotFound as SharedNotFound } from '@valiant/ui-shared'

export function NotFound() {
  return <SharedNotFound />
}
